module.exports = __webpack_public_path__ + "img/img_08.8e1da52a.png";